/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetCommissionRatesResponse } from '../models/GetCommissionRatesResponse';
import type { UpsertCommissionRateRequestBody } from '../models/UpsertCommissionRateRequestBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CommissionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns GetCommissionRatesResponse OK
     * @throws ApiError
     */
    public getCommissionRatesForShop({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<GetCommissionRatesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/commission',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public upsertCommissionRate({
        requestBody,
    }: {
        requestBody: UpsertCommissionRateRequestBody,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/commission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
